import React, { useState, useEffect } from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const [visibleSteps, setVisibleSteps] = useState(new Set());

  const steps = [
    {
      number: '01',
      title: 'Share Your Story',
      description: 'Tell us about your business, challenges & legal needs.',
      icon: '🎯'
    },
    {
      number: '02',
      title: 'Smart Strategy',
      description: 'We analyze & craft a tailored legal strategy.',
      icon: '⚡'
    },
    {
      number: '03',
      title: 'Execution',
      description: 'We handle documentation & legal processes.',
      icon: '✅'
    },
    {
      number: '04',
      title: 'Ongoing Support',
      description: 'We\'re your legal partner for life.',
      icon: '🛡️'
    }
  ];

  const benefits = [
    { icon: '⚖️', text: 'Transparent Process' },
    { icon: '⏰', text: 'On-Time Delivery' },
    { icon: '💰', text: 'Fixed Fees' },
    { icon: '👥', text: 'Dedicated Support' }
  ];

  useEffect(() => {
    const handleIntersection = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisibleSteps(prev => new Set(prev).add(parseInt(entry.target.dataset.stepId)));
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.3
    });

    const stepElements = document.querySelectorAll('.flow-step');
    stepElements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="how-it-works-container">
        <div className="section-header">
          <p className="section-label">HOW IT WORKS</p>
          <h2 className="section-title">
            Simple Process.<br />Powerful Results.
          </h2>
          <p className="section-subtitle">We keep it simple, so you can focus on what you do best.</p>
        </div>

        {/* Animated Flow Diagram */}
        <div className="flow-diagram">
          <div className="flow-steps-container">
            {steps.map((step, index) => (
              <div 
                key={index}
                className={`flow-step ${visibleSteps.has(index) ? 'visible' : ''}`}
                data-step-id={index}
              >
                {/* Step Circle */}
                <div className="flow-step-circle">
                  <div className="flow-step-icon">{step.icon}</div>
                </div>

                {/* Step Number */}
                <div className="flow-step-number">{step.number}</div>

                {/* Step Content */}
                <div className="flow-step-content">
                  <h3 className="flow-step-title">{step.title}</h3>
                  <p className="flow-step-description">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Benefits Section */}
        <div className="benefits-section">
          <div className="benefits-header">
            <h3 className="benefits-title">
              <span className="benefits-icon">✨</span>
              Why Choose LexPitch?
            </h3>
            <p className="benefits-subtitle">Legal clarity at every step. That's the LexPitch way.</p>
          </div>

          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon-wrapper">
                  <span className="benefit-icon-large">{benefit.icon}</span>
                </div>
                <p className="benefit-text">{benefit.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
